import { render, staticRenderFns } from "./send_mail.vue?vue&type=template&id=220687a2&scoped=true&"
import script from "./send_mail.vue?vue&type=script&lang=js&"
export * from "./send_mail.vue?vue&type=script&lang=js&"
import style0 from "./send_mail.vue?vue&type=style&index=0&id=220687a2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "220687a2",
  null
  
)

export default component.exports